<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div class="crumbs-box-p">
        <span>匠心记</span>
        <span>&gt;</span>
        <span>创建QE报告</span>
      </div>
      <!-- 主体 -->
      <!-- 基础检查 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%">
        <h2 class="create-qe-tit-p">创建QE报告</h2>
        <div class="create-title-p">
          <input type="text"
                 placeholder="请输入QE报告的正文标题"
                 v-model="title" />
        </div>
        <upload-report-file class="create-cover-p"
                            ref="cover"
                            @getReportDataArr="getReportDataArr"
                            style="border-bottom: none;padding-bottom: 0px;">
          <span slot="title">基础检查</span>
          <span slot="remark">上传《现场基础情况检查告知函》(图片或PDF二选一上传)&nbsp;</span>
        </upload-report-file>
      </div>
      <!-- 现场标样制作 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getSceneStandardMakeShow">
        <scene-standard-make-node class="material-edit-p"
                                  ref="scene"
                                  style="padding-top: 0px;padding-bottom: 25px;margin-bottom: 20px;"
                                  @getSceneStandardMakeData="getSceneStandardMakeData">
          <span slot="title">现场标样制作</span>
        </scene-standard-make-node>
      </div>
      <!-- 原材料进场 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getRawMaterialEnterShow">
        <raw-material-enter class="quality-edit-p"
                            ref="quality"
                            :rawCheckFlag="getRawMaterialCheckShow"
                            @getRowEnterDataArr="getRowEnterDataArr"
                            style="padding: 0px 20px 0px 0px;">
          <span slot="title">原材料进场</span>
          <template slot="radioInfo">
            <template>
              <el-radio-group v-model="rowRadioValue"
                              text-color="#626aef"
                              size="small"
                              fill="rgb(239, 240, 253)"
                              style="margin-bottom:1%;margin-top: 0.5%;">
                <el-radio border
                          :label=1>良好</el-radio>
                <el-radio border
                          :label=2>预警</el-radio>
                <el-radio border
                          :label=3>异常</el-radio>
              </el-radio-group>
            </template>
            <div class="create-title-p"
                 style="margin: 0px;padding-bottom: 10px;">
              <input type="text"
                     placeholder="描述"
                     v-model="rowRadioRemark" />
            </div>
          </template>
          <template slot="checkInfo">
            <div class="create-title-p">
              <input type="text"
                     placeholder="请输入送检检测机构名称"
                     v-model="checkInstitutionName" />
            </div>
            <div class="create-title-p">
              <input type="text"
                     placeholder="请输入检测结果描述"
                     v-model="checkResult" />
            </div>
          </template>
        </raw-material-enter>
      </div>
      <!-- 施工过程管控 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getConControlNodeShow">
        <construction-control-node class="material-edit-p"
                                   ref="material"
                                   style="padding-top: 0px;padding-bottom: 25px;margin-bottom: 20px;"
                                   @getConstructionControlData="getConstructionControlData">
          <span slot="title">施工过程管控</span>
        </construction-control-node>
      </div>
      <!-- 避免气候、交叉施工等外部因素影响 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getExtrinsicFactorsShow">
        <extrinsic-factors-node class="material-edit-p"
                                ref="extrinsic"
                                style="padding-top: 0px;padding-bottom: 25px;margin-bottom: 20px;"
                                @getExtrinsicFactorsData="getExtrinsicFactorsData">
          <span slot="title">避免气候、交叉施工等外部因素影响</span>
        </extrinsic-factors-node>
      </div>
      <!-- 成品抽检 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getProSpotCheckShow">
        <product-spot-check class="material-edit-p"
                            ref="spot"
                            @getProSpotCheckDataArr="getProSpotCheckDataArr"
                            style="padding-top: 0px;padding-bottom: 20px;">
          <span slot="title">成品抽检</span>
          <template slot="checkInfo">
            <div class="create-title-p">
              <input type="text"
                     placeholder="请输入送检检测机构名称"
                     v-model="proCheckInstitutionName" />
            </div>
            <div class="create-title-p">
              <input type="text"
                     placeholder="请输入检测结果描述"
                     v-model="proCheckResult" />
            </div>
          </template>
        </product-spot-check>
      </div>
      <!-- 信息反馈 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getInfoFeedbackShow">
        <info-feedback class="material-edit-p"
                       ref="info"
                       @getInfoFeedbackDataArr="getInfoFeedbackDataArr"
                       style="padding-top: 0px;padding-bottom: 20px;">
          <span slot="title">信息反馈</span>
          <span slot="remark">上传《现场品控工程师信息反馈表》(图片或PDF二选一上传)&nbsp;</span>
        </info-feedback>
      </div>
      <div class="carate-qe-main-p">
        <div class="qe-btn-p">
          <p>取消</p>
          <p @click="create">保存</p>
        </div>
      </div>

      <aside-right @scrollToCover="scrollToCover"
                   @scrollToScene="scrollToScene"
                   @scrollToQuality="scrollToQuality"
                   @scrollToMaterial="scrollToMaterial"
                   @scrollToExtrinsic="scrollToExtrinsic"
                   @scrollToSpot="scrollToSpot"
                   @scrollToInfo="scrollToInfo"
                   @scrollToTop="scrollToTop" />
    </div>
  </div>
</template>
	  
<script>
import "../../../../html/pages/originality/createQe/testQE.scss"

import ImageUpload from "../../../../components/imageUpload/ImageUpload"
import uploadReportFile from "./components/uploadReportFile.vue"
import asideRight from "./components/newAsideRight.vue"

import { jxjAddQEReportV2 } from "../../../../api/index"
import RawMaterialEnter from './components/rawMaterialEnter.vue'
import ConstructionControlNode from './components/constructionControlNode.vue'
import ExtrinsicFactorsNode from './components/extrinsicFactorsNode.vue'
import ProductSpotCheck from './components/productSpotCheck.vue'
import InfoFeedback from './components/infoFeedback.vue'
import SceneStandardMakeNode from './components/sceneStandardMakeNode.vue'

export default {
  name: 'newCreateQE',
  data () {
    return {
      id: "",
      rotate: '',
      params: {//总参
        ForumsId: "",
        Name: "",
        Content1: [],
        //token: "fb4b719afa2db43ed0f03e1446672cd959fd1070"
      },
      sceneStandardMakeNode: {
        nodeName: "现场标样制作",
        subnodelist: []
      },
      sceneStandardMakeNodeCount: 2,// 现场标样制作
      constructionControlData: {
        nodeName: "施工过程管控",
        subnodelist: [
          {
            nodeName: "",
            subnodelist: [],
            nodeState: 0
          }
        ]
      },
      conControlNodeCount: 19,// 施工过程管控，当前模板写死，选项节点数量固定
      extrinsicFactorsData: {
        nodeName: "避免气候、交叉施工等外部因素影响",
        subnodelist: []
      },
      extrinsicFactorsNodeCount: 4,// 外部因素，当前模板写死，选项节点数量固定
      title: "",
      picDataArr: [],//基础检查原图
      extraData: {//基础检查文件
        type: '',
        file: ''
      },
      baseFileType: "",//基础检查 文件类型
      rowRadioValue: 0,
      rowRadioRemark: '',
      rowPicDataArr: [],//原材料进场 原图
      checkInstitutionName: "",//原材料进场 检检测机构名称
      checkResult: "",// 原材料进场 检测结果描述
      rowCheckPicDataArr: [],//原材料抽检 原图
      rowCheckFileData: {//原材料抽检 文件
        type: '',
        file: ''
      },
      proCheckInstitutionName: "",//成品抽检 检检测机构名称
      proCheckResult: "",//成品抽检 检测结果描述
      proCheckPicDataArr: [],//成品抽检原图
      proCheckFileData: {//成品抽检文件
        type: '',
        file: ''
      },
      infoFeedbackPicArr: [],//信息反馈 图片
      infoFeedbackFileData: {//信息反馈 文件
        type: '',
        file: ''
      },
      infoFileType: "",//信息反馈 文件类型
    }
  },
  computed: {
    getSceneStandardMakeShow () {//现场标样制作
      return this.title.length > 0 && (this.picDataArr.length > 0 || this.extraData.file.length > 0)
    },
    getRawMaterialEnterShow () {//原材料进场
      if (!this.getSceneStandardMakeShow) return false;

      if (this.sceneStandardMakeNode.subnodelist.length < 1) {
        return false;
      }
      let subnodeCount = 0
      for (let subnode of this.sceneStandardMakeNode.subnodelist) {
        if (subnode.nodeState > 0 && subnode.remark && subnode.remark.length > 0 && subnode.picArr && subnode.picArr.length > 0) {
          subnodeCount = subnodeCount + 1
        } else {
          return false
        }
      }
      if (subnodeCount === this.sceneStandardMakeNodeCount) {
        return true
      }
      return false
    },
    getRawMaterialCheckShow () {//原材料抽检
      if (!this.getRawMaterialEnterShow) return false;
      if (this.rowRadioValue > 0 && this.rowPicDataArr.length > 0) {
        if (2 == this.rowRadioValue || 3 == this.rowRadioValue) {
          if (this.rowRadioRemark.length < 1) return false
        }
        return true
      }
      return false
    },
    getConControlNodeShow () {//施工过程管控
      if (!this.getRawMaterialCheckShow) return false;
      //console.log("getConControlNodeShow", this);
      return this.rowRadioValue > 0 && this.rowPicDataArr.length > 0 && this.rowCheckPicDataArr.length > 0 &&
          this.checkInstitutionName.length > 0 && this.checkResult.length > 0
    },
    getExtrinsicFactorsShow () {//外部因素
      if (!this.getConControlNodeShow) return false;
      if (this.constructionControlData.subnodelist.length > 0) {
        let subnodeCount = 0
        for (let subnode of this.constructionControlData.subnodelist) {
          if (subnode.subnodelist.length > 0) {
            for (let grandsonNode of subnode.subnodelist) {
              if (grandsonNode.nodeState > 0 && grandsonNode.remark && grandsonNode.remark.length > 0 && grandsonNode.picArr && grandsonNode.picArr.length > 0) {
                subnodeCount = subnodeCount + 1
              } else {
                return false
              }
            }
          } else {
            return false
          }
        }
        if (subnodeCount === this.conControlNodeCount) {
          return true
        }
      } else {
        return false
      }
    },
    getProSpotCheckShow () {//成品抽检
      if (!this.getExtrinsicFactorsShow) return false;
      console.log(this.extrinsicFactorsData)
      if (this.extrinsicFactorsData.subnodelist.length > 0) {
        let subnodeCount = 0
        for (let subnode of this.extrinsicFactorsData.subnodelist) {
          if (subnode.nodeState > 0 && subnode.remark && subnode.remark.length > 0 && subnode.picArr && subnode.picArr.length > 0) {
            subnodeCount = subnodeCount + 1
          } else {
            return false
          }
        }
        if (subnodeCount === this.extrinsicFactorsNodeCount) {
          return true
        }
      } else {
        return false
      }
    },
    getInfoFeedbackShow () {//信息反馈
      if (!this.getProSpotCheckShow) return false;
      return this.proCheckPicDataArr.length > 0 && this.proCheckInstitutionName.length > 0 && this.proCheckResult.length > 0
    }
  },
  components: {
    ImageUpload,
    asideRight,
    uploadReportFile,
    RawMaterialEnter,
    ConstructionControlNode,
    ExtrinsicFactorsNode,
    ProductSpotCheck,
    InfoFeedback,
    SceneStandardMakeNode
  },
  methods: {
    getReportDataArr (picDataList, extraDataObj, type) {
      //   console.log("getReportDataArr", picDataList)
      //   console.log("getReportDataArr", extraDataObj)
      this.picDataArr = picDataList
      this.extraData = extraDataObj
      this.baseFileType = type
      //console.log("getReportDataArr", this)
    },
    getSceneStandardMakeData (sceneStandardMakeDataArr) {
      //console.log("getSceneStandardMakeData", sceneStandardMakeDataArr)
      this.sceneStandardMakeNode.subnodelist = sceneStandardMakeDataArr
      //console.log("getSceneStandardMakeData", this.sceneStandardMakeNode)
    },
    getRowEnterDataArr (rowPicDataList, rowCheckPicDataList, rowCheckFile) {
      //   console.log("getRowEnterDataArr", rowPicDataList)
      //   console.log("getRowEnterDataArr", rowCheckPicDataList)
      //   console.log("getRowEnterDataArr", rowCheckFile)
      this.rowPicDataArr = rowPicDataList
      this.rowCheckPicDataArr = rowCheckPicDataList
      this.rowCheckFileData = rowCheckFile
    },
    getConstructionControlData (constructionControlData) {
      //console.log("getConstructionControlData", constructionControlData)
      this.constructionControlData.subnodelist = constructionControlData
      //console.log("getConstructionControlData", this.constructionControlData)
    },
    getExtrinsicFactorsData (extrinsicFactorsDataArr) {
      //console.log("getExtrinsicFactorsData", extrinsicFactorsDataArr)
      this.extrinsicFactorsData.subnodelist = extrinsicFactorsDataArr
      //console.log("getExtrinsicFactorsData", this.extrinsicFactorsData)
    },
    getProSpotCheckDataArr (proCheckPicDataArr, proCheckFileData) {
      //   console.log("getProSpotCheckDataArr", picDataList)
      //   console.log("getProSpotCheckDataArr", extraDataObj)
      this.proCheckPicDataArr = proCheckPicDataArr
      this.proCheckFileData = proCheckFileData
    },
    getInfoFeedbackDataArr (infoFeedbackPicArr, infoFeedbackFileData, type) {
      //   console.log("getInfoFeedbackDataArr", infoFeedbackPicArr)
      //   console.log("getInfoFeedbackDataArr", infoFeedbackFileData)
      this.infoFeedbackPicArr = infoFeedbackPicArr
      this.infoFeedbackFileData = infoFeedbackFileData
      this.infoFileType = type
      //console.log("getInfoFeedbackDataArr", this)
    },
    async create () {
      /*
      **数据整合
      */

      if (!this.title) return this.$layer.alert("请填写QE报告标题！")
      if (this.picDataArr.length === 0 && this.extraData.file.length === 0) return this.$layer.alert("请上传《现场基础情况检查告知函》！")
      // 现场标样制作：只在显示时验证
      if (this.getSceneStandardMakeShow) {
        if (this.sceneStandardMakeNode.subnodelist.length > 0) {
          for (let subnode of this.sceneStandardMakeNode.subnodelist) {
            if(!subnode.picArr || subnode.picArr.length < 1){
              return this.$layer.alert("请上传现场标样制作'"+subnode.nodeName+"'图片！")
            }
            if(subnode.nodeState < 1){
              return this.$layer.alert("请完成现场标样制作'"+subnode.nodeName+"'节点状态！")
            }
            if(!subnode.remark || subnode.remark.length < 1){
              return this.$layer.alert("请完成现场标样制作'"+subnode.nodeName+"'描述信息！")
            }
          }
        }else {
          return this.$layer.alert("请完善现场标样制作内容！")
        }
      }
      // 原材料进场：只在显示时验证
      if (this.getRawMaterialEnterShow) {
        if(!this.rowPicDataArr || this.rowPicDataArr.length < 1){
          return this.$layer.alert("请上传原材料储存图片！")
        }
        if(!this.rowRadioValue || this.rowRadioValue < 1){
          return this.$layer.alert("请完成原材料储存节点状态！")
        }
        if(!this.rowRadioRemark || this.rowRadioRemark.length < 1){
          return this.$layer.alert("请完成原材料储存描述！")
        }
        // if (this.rowRadioValue > 0 || this.rowPicDataArr.length > 0) {
        // if (2 == this.rowRadioValue || 3 == this.rowRadioValue) {
        //   if (this.rowRadioRemark.length < 1) return this.$layer.alert("请完善原材料储存内容！")
        // }
        // }
      }
      // 原材料抽检：依赖原材料进场显示
      if (this.getRawMaterialCheckShow) {

        if(!this.rowCheckPicDataArr || this.rowCheckPicDataArr.length < 1){
          return this.$layer.alert("请上传原材料抽检图片！")
        }
        if(!this.checkInstitutionName || this.checkInstitutionName.length < 1){
          return this.$layer.alert("请完成原材料抽检送检机构名称！")
        }
        if(!this.checkResult || this.checkResult.length < 1){
          return this.$layer.alert("请完成原材料抽检送检检测结果描述！")
        }


        // if (this.rowCheckPicDataArr.length > 0 || this.checkInstitutionName.length > 0 || this.checkResult.length > 0) {
        //   if (this.rowCheckPicDataArr.length < 1 || this.checkInstitutionName.length < 1 || this.checkResult.length < 1) {
        //     return this.$layer.alert("请完善原材料抽检内容！")
        //   }
        // }
      }
      //施工过程管控
      if (this.getConControlNodeShow) {
        if (this.constructionControlData.subnodelist.length > 0) {
          // let subnodeCount = 0
          for (let subnode of this.constructionControlData.subnodelist) {
            if (subnode.subnodelist.length > 0) {
              for (let grandsonNode of subnode.subnodelist) {

                if(!grandsonNode.picArr || grandsonNode.picArr.length < 1){
                  return this.$layer.alert("请上传施工过程管控'"+subnode.nodeName+"_"+grandsonNode.nodeName+"'图片！")
                }
                if(grandsonNode.nodeState < 1){
                  return this.$layer.alert("请完成施工过程管控'"+subnode.nodeName+"_"+grandsonNode.nodeName+"'节点状态！")
                }
                if(!grandsonNode.remark || grandsonNode.remark.length < 1){
                  return this.$layer.alert("请完成施工过程管控'"+subnode.nodeName+"_"+grandsonNode.nodeName+"'描述信息！")
                }

                // if (grandsonNode.nodeState > 0 && grandsonNode.remark && grandsonNode.remark.length > 0 && grandsonNode.picArr && grandsonNode.picArr.length > 0) {
                //   subnodeCount = subnodeCount + 1
                // } else {
                //   return this.$layer.alert("请完善施工过程管控内容！")
                // }
              }
            }else {
              return this.$layer.alert("请完善施工过程管控内容！")
            }
          }

        } else {
          return this.$layer.alert("请完善施工过程管控内容！")
        }
      }

      //外部因素
      if (this.getExtrinsicFactorsShow) {
        if (this.extrinsicFactorsData.subnodelist.length > 0) {
          // let subnodeCount = 0
          for (let subnode of this.extrinsicFactorsData.subnodelist) {

            if(!subnode.picArr || subnode.picArr.length < 1){
              return this.$layer.alert("请上传外部因素'"+subnode.nodeName+"'图片！")
            }
            if(subnode.nodeState < 1){
              return this.$layer.alert("请完成外部因素'"+subnode.nodeName+"'节点状态！")
            }
            if(!subnode.remark || subnode.remark.length < 1){
              return this.$layer.alert("请完成外部因素'"+subnode.nodeName+"'描述信息！")
            }
            // if (subnode.nodeState > 0 && subnode.remark && subnode.remark.length > 0 && subnode.picArr && subnode.picArr.length > 0) {
            //   subnodeCount = subnodeCount + 1
            // } else {
            //   return this.$layer.alert("请完善外部因素内容！")
            // }
          }
          // if (subnodeCount !== this.extrinsicFactorsNodeCount) {
          //   return this.$layer.alert("请完善外部因素内容！")
          // }
        } else {
          return this.$layer.alert("请完善外部因素内容！")
        }

      }

      // 成品抽检：只在显示时验证
      if (this.getProSpotCheckShow) {
        // if (this.proCheckPicDataArr.length > 0 || this.proCheckInstitutionName.length > 0 || this.proCheckResult.length > 0) {
        //   if (this.proCheckPicDataArr.length < 1 || this.proCheckInstitutionName.length < 1 || this.proCheckResult.length < 1) {
        //     return this.$layer.alert("请完善成品抽检内容！")
        //   }
        // }


        if(!this.proCheckPicDataArr || this.proCheckPicDataArr.length < 1){
          return this.$layer.alert("请上传成品抽检图片！")
        }
        if(!this.proCheckInstitutionName || this.proCheckInstitutionName.length < 1){
          return this.$layer.alert("请完成成品抽检检检测机构名称！")
        }
        if(!this.proCheckResult || this.proCheckResult.length < 1){
          return this.$layer.alert("请完成成品抽检检测结果描述！")
        }

        // if(!(this.proCheckPicDataArr.length > 0 && this.proCheckInstitutionName.length > 0 && this.proCheckResult.length > 0)){
        //   return this.$layer.alert("请完善成品抽检内容！")
        // }
      }

      let params = this.params
      //console.log("create", params)
      params.Name = this.title
      params.ForumsId = this.id
      let content1 = []

      // 基础检查
      let baseCheckUrl = []
      if (this.picDataArr.length > 0 && "IMG" == this.baseFileType) {
        baseCheckUrl = this.picDataArr
      } else {
        baseCheckUrl.push(this.extraData.file);
      }
      let baseCheck = {
        nodeName: "基础检查",
        img: baseCheckUrl
      }
      content1.push(baseCheck);
      // 现场标样制作（只在显示时添加数据）
      if (this.getSceneStandardMakeShow) {
        content1.push(this.sceneStandardMakeNode);
      }
      // 原材料进场（只在显示时添加数据）
      if (this.getRawMaterialEnterShow) {
        let rawEnter = {
          nodeName: '原材料进场',
          img: [],
          nodeState: 0,
          subnodelist: [
            {
              nodeName: '原材料储存',
              img: this.rowPicDataArr,
              nodeState: this.rowRadioValue,
              remark: this.rowRadioRemark
            },
            {
              nodeName: '原材料抽检',
              img: this.rowCheckPicDataArr,
              checkInstitutionName: this.checkInstitutionName,
              checkResult: this.checkResult,
              file: this.rowCheckFileData.file,
            }
          ]
        }
        content1.push(rawEnter);
      }
      // 施工过程管控（只在显示时添加数据）
      if (this.getConControlNodeShow) {
        content1.push(this.constructionControlData);
      }
      // 避免气候、交叉施工等外部因素影响
      // 外部因素（只在显示时添加数据）
      if (this.getExtrinsicFactorsShow) {
        content1.push(this.extrinsicFactorsData);
      }
      // 成品抽检（只在显示时添加数据）
      if (this.getProSpotCheckShow) {

        let proCheck = {
          nodeName: '成品抽检',
          img: this.proCheckPicDataArr,
          checkInstitutionName: this.proCheckInstitutionName,
          checkResult: this.proCheckResult,
          file: this.proCheckFileData.file,
        }
        content1.push(proCheck);
      }
      // 信息反馈（只在显示时添加数据）
      if (this.getInfoFeedbackShow) {

        let infoCheckUrl = []
        if (this.infoFeedbackPicArr.length > 0 && "IMG" == this.infoFileType) {
          infoCheckUrl = this.infoFeedbackPicArr
        } else {
          infoCheckUrl.push(this.infoFeedbackFileData.file);
        }
        let infoCheck = {
          nodeName: "信息反馈",
          img: infoCheckUrl
        }
        content1.push(infoCheck);
      }
      // 封装
      let contentObj = {
        type: "4",
        data: JSON.stringify(content1)
      }
      params.Content1.push(contentObj)
      //console.log("create", params)
      // 创建qe报告
      let reportRes = await jxjAddQEReportV2(params)
      if (reportRes.Type == 'Success') {
        this.$layer.msg(reportRes.Content, (msg) => {
          this.$layer.close(msg)
          this.$router.push({ name: "jxjDetail", params: { id: this.$route.params.id } })
        })
      } else if (reportRes.Type == 'Error' || reportRes.Type == 'Warning') {
        this.$layer.alert(reportRes.Content);
      }
    },
    scrollToCover () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.cover.offsetTop - 60
    },
    scrollToScene () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.scene.$el.offsetTop - 60
    },
    scrollToQuality () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.quality.$el.offsetTop - 60
    },
    scrollToMaterial () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.material.$el.offsetTop - 60
    },
    scrollToExtrinsic () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.extrinsic.$el.offsetTop - 60
    },
    scrollToSpot () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.spot.$el.offsetTop - 60
    },
    scrollToInfo () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.info.$el.offsetTop - 60
    },
    scrollToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
  },
  created () {
    this.id = this.$route.params.id
  }
}
</script>
	  
	  